import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {inject} from '@angular/core';
import {getUser} from '@portal-workspace/grow-ui-library';
import {navigationUrlForUnactivatedAccount} from '../service/navigation-urls';


export const activatedAccountGuard = () => {
  return (
    route: ActivatedRouteSnapshot, state: RouterStateSnapshot
  ) => {
    const router = inject(Router);
    const user = getUser();
    if (user) {
      if (user.approval == 0 || user.rejected == 1) {
        return router.navigate(navigationUrlForUnactivatedAccount())
      }
    }
    return true;
  }
}
